import * as React from "react";
import {Icon, IConcreteIcon} from "../Icon";

export const TransferIcon = ({style}: IConcreteIcon) => <Icon file="/icons/payment_methods/banktransfer.svg" style={style} />;
